import styled, { css } from 'styled-components'

export const Wrapper = styled.div``

interface IRowProps {
  marginbottom: string
}

export const Row = styled.div`
  h3 {
    border-radius: 8px;
    height: 40px !important;
    margin-top: 0 !important;
    ${(props: IRowProps) =>
      css`
        margin-bottom: ${props.marginbottom}px;
      `}
  }
  ul {
    display: none;
  }
`
